import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SharedService } from '../../../services/shared/shared.service';

@Component({
  selector: 'copy-link',
  templateUrl: './copy-link.component.html',
  styleUrls: ['./copy-link.component.scss'],
})
export class CopyLinkComponent implements OnChanges {
  @Input() links: any;

  copyLinkForm: UntypedFormGroup;
  isCopied1 = false;

  constructor(
    private _fb: UntypedFormBuilder,
    private _sharedService: SharedService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.links) {
        this.links = '';
        this.links = changes.links.currentValue;
      }
    }
  }

  getLink() {
    this._sharedService.openSnackBar('link copied', 'ok');
  }
}
